(() => {
  const MIN_CHARS = 2;
  const DEBOUNCE_MS = 180;

  function debounce(fn, ms) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), ms);
    };
  }

  function closeBox(box) {
    if (box) box.remove();
  }

  function ensureBox(input) {
    // wrapper zoeken (form/field)
    const host = input.closest('form') || input.parentElement;
    if (!host) return null;

    // al aanwezig?
    let box = host.querySelector('.custom-predictive');
    if (box) return box;

    box = document.createElement('div');
    box.className = 'custom-predictive';
    host.style.position = host.style.position || 'relative';
    host.appendChild(box);
    return box;
  }

  async function fetchSuggestions(q) {
    const url =
      `/search/suggest.json?q=${encodeURIComponent(q)}` +
      `&resources[type]=product,collection,page,article` +
      `&resources[limit]=6` +
      `&resources[options][unavailable_products]=hide` +
      `&resources[options][fields]=title,product_type,variants.title`;

    const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
    if (!res.ok) return null;
    return await res.json();
  }

  function render(box, data, q) {
    if (!data || !data.resources || !data.resources.results) {
      box.innerHTML = '';
      box.classList.remove('is-open');
      return;
    }

    const r = data.resources.results;
    const products = r.products || [];
    const collections = r.collections || [];
    const pages = r.pages || [];
    const articles = r.articles || [];

    const hasAny = products.length || collections.length || pages.length || articles.length;

    if (!hasAny) {
      box.innerHTML = `<div class="custom-predictive__empty">Geen resultaten voor “${escapeHtml(q)}”.</div>`;
      box.classList.add('is-open');
      return;
    }

    const section = (title, items, itemTpl) => {
      if (!items || !items.length) return '';
      return `
        <div class="custom-predictive__section">
          <div class="custom-predictive__title">${title}</div>
          <div class="custom-predictive__items">
            ${items.map(itemTpl).join('')}
          </div>
        </div>
      `;
    };

    box.innerHTML = `
      ${section('Producten', products, (p) => `
        <a class="custom-predictive__item" href="${p.url}">
          ${p.featured_image?.url ? `<img class="custom-predictive__img" src="${p.featured_image.url}&width=80" alt="">` : ''}
          <span class="custom-predictive__text">${escapeHtml(p.title)}</span>
        </a>
      `)}
      ${section('Collecties', collections, (c) => `
        <a class="custom-predictive__item" href="${c.url}">
          <span class="custom-predictive__text">${escapeHtml(c.title)}</span>
        </a>
      `)}
      ${section('Pagina’s', pages, (p) => `
        <a class="custom-predictive__item" href="${p.url}">
          <span class="custom-predictive__text">${escapeHtml(p.title)}</span>
        </a>
      `)}
      ${section('Blogs', articles, (a) => `
        <a class="custom-predictive__item" href="${a.url}">
          <span class="custom-predictive__text">${escapeHtml(a.title)}</span>
        </a>
      `)}
    `;
    box.classList.add('is-open');
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, (m) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    }[m]));
  }

  const onInput = debounce(async (e) => {
    const input = e.target;
    if (!input.matches('input[type="search"]')) return;

    const q = input.value.trim();
    const box = ensureBox(input);
    if (!box) return;

    if (q.length < MIN_CHARS) {
      box.innerHTML = '';
      box.classList.remove('is-open');
      return;
    }

    const data = await fetchSuggestions(q);
    render(box, data, q);
  }, DEBOUNCE_MS);

  document.addEventListener('input', onInput);

  // sluiten bij klik buiten / escape / blur
  document.addEventListener('click', (e) => {
    document.querySelectorAll('.custom-predictive.is-open').forEach((box) => {
      if (!box.contains(e.target) && !(box.closest('form') || box.parentElement)?.contains(e.target)) {
        box.classList.remove('is-open');
      }
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.custom-predictive.is-open').forEach((box) => box.classList.remove('is-open'));
    }
  });
})();
